/* eslint-disable */
import React from 'react';
import { connect } from "react-redux";
import {
    Input,
    Button,
    Navbar,
    Nav,
    NavLink,
    Col,
    Row,
    Spinner,
    UncontrolledTooltip,
} from 'reactstrap'
import NavBar from '../../components/NavBar/navBar'
import radioButton from '../../assets/radioButton.svg'
import { faCalendar } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { NavLink as RRNavLink } from 'react-router-dom';
import zoomInIcon from '../../assets/zoom-in.svg'
import zoomOutIcon from '../../assets/zoom-out.svg'
import ImageMapper from '../../components/ImageMapper/imageMapper'
import ResultDisplaySamples from '../../components/ResultDisplaySamples/resultDisplaySamples'
import FloorResultDisplay from '../../species/FloorResultDisplay/floorResultDisplay'
import Tour from '../../Tour';
import eyeIcon from '../../assets/eye-highlight.svg'
import listIcon from '../../assets/list-blue.svg'
import radioButtonhighlighted from '../../assets/radioButtonhighlighted.svg'
import {
    fetchBuilding,
    fetchFloors,
    fetchFloorPlan,
    fetchLocationResultsData,
    saveSample,
    updateSample,
    deleteSample,
    fetchFilterOptions
} from '../../actions'

import '../../components/ResultDisplay/resultDisplay.css'
import "react-datepicker/dist/react-datepicker.css";
import { toast, ToastContainer } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin, appInsights } from '../../AppInsights';
import { SeverityLevel } from '@microsoft/applicationinsights-common';
let building=sessionStorage.getItem("building")
let buildingId=sessionStorage.getItem("buildingId")
let buildingName=sessionStorage.getItem("buildingName")
let floor=sessionStorage.getItem("floor")
let floorId=sessionStorage.getItem("floorId")
let floorName=sessionStorage.getItem("floorName")

const initialState = {
    name: "floor-map",
    width: 0,
    height: 0,
    analysis:"SNP",
    checkedState:true,
    show: false,
    filterComplexList: [],
    resultBuilding:  building?building:"",
    resultFloor: floor?floor:"",
    resultOrganism: localStorage.getItem("guest")?"Salmonella":"",
    resultBatchNo: "",
    resultSampleType: "",
    zoomInEnabled: true,
    zoomOutEnabled: true
}

let edit = false
let isDisable = false
let errorDetails = ""
let editSampleId = ""

class ResultDisplay extends React.Component {
    constructor(props) {
        super(props);
        this.props.fetchFilterOptions()
        this.props.fetchBuilding()
        this.onChange = this.onChange.bind(this)
        this.onSelectBuilding = this.onSelectBuilding.bind(this)
        this.onSelectFloor = this.onSelectFloor.bind(this)
        this.onDateChange = this.onDateChange.bind(this)
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

        building=sessionStorage.getItem("building")
        floor=sessionStorage.getItem("floor")
        this.floorInitialState = {
            resultBuilding: building?building:localStorage.getItem("guest")?"BldgA":"",
            resultFloor: floor?floor:localStorage.getItem("guest")?20000:"",
            floorId: floorId?floorId:localStorage.getItem("guest")?20000:"",
            buildingId: buildingId?buildingId:localStorage.getItem("guest")?20000:"",
            datetime: localStorage.getItem("guest")?new Date(moment().subtract(1, "days")): "",
            todatetime: localStorage.getItem("guest")?new Date(moment().subtract(1, "days")): "",
            show: localStorage.getItem("guest")?true:false,
            resultOrganism: "",
            resultSampleType: "",
            clickedFloorArea: undefined,
            floorSampleResults: undefined,
            building: building?building:localStorage.getItem("guest")?"BldgA":"",
            floor: floor?floor:localStorage.getItem("guest")?20000:"",
            buildingName: buildingName?buildingName:localStorage.getItem("guest")?"Building A":"",
            floorName: floorName?floorName:localStorage.getItem("guest")?"Floor A":"",
            loader: false
        }
        this.state = Object.assign(initialState, this.floorInitialState);
        
        setTimeout(() => {
            if(localStorage.getItem("guest"))
            this.applyFilter()
        });
        
        this.floorElement = element => {

            if (element) {
                let floorDim = element.container.getBoundingClientRect()
                this.setState({
                    leftFloor: floorDim.left,
                    topFloor: floorDim.top,
                });
            }
        };
    }


    componentWillMount()
    {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }
    componentDidMount() {   
        if(sessionStorage.getItem("building"))
        this.onSelectBuilding("",true)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions() {
        let width = window.innerWidth * 0.66
        this.setState({ width: 865, height: 550, zoomOutEnabled: false, zoomInEnabled: width<2000?true:false});
    }
    

    onSelectFloor = (event,flag=false) => {
        if(flag===false)
        {
        const {value,selectedOptions}=event.target
        sessionStorage.setItem("floorName",selectedOptions[0].innerText)
        sessionStorage.setItem("floorId",selectedOptions[0].id)
        sessionStorage.setItem("floor",value)
        }       
         this.setState(prevState => ({
            ...this.state,
            resultFloor: sessionStorage.getItem("floor"),
            floorId:sessionStorage.getItem("floorId"),
            floorName:sessionStorage.getItem("floorName"),
            floor_plan: flag? prevState.floor_plan: "",
            show: false,
        }))
    }

onSelectBuilding = (event,flag=false) => {
    if(flag===false)
    {
    const {value,selectedOptions}=event.target
    sessionStorage.setItem("building",value)
    sessionStorage.setItem("buildingId",selectedOptions[0].id)
    sessionStorage.setItem("buildingName",selectedOptions[0].innerText)
    sessionStorage.setItem("floor","")
    sessionStorage.setItem("floorId","")
    sessionStorage.setItem("floorName","")
    }
        this.setState( prevState => ({
            ...this.state,
            resultBuilding:sessionStorage.getItem("building"),
            buildingId: sessionStorage.getItem("buildingId"),
            buildingName:sessionStorage.getItem("buildingName"),
            resultFloor: "",
            floorId:flag? prevState.floorId: "",
            floorName:flag? prevState.floorName: "",
            areas: flag? prevState.areas: [],
            floor_plan: flag? prevState.floor_plan: "",
            show: false,
        }), async() => {
           await this.props.fetchFloors(this.state.buildingId)
            if(sessionStorage.getItem("floor"))
           await this.onSelectFloor("",true)
        })
    }

    onSelectFloor = (event,flag=false) => {
        if(flag===false)
        {
        const {value,selectedOptions}=event.target
        sessionStorage.setItem("floorName",selectedOptions[0].innerText)
        sessionStorage.setItem("floorId",selectedOptions[0].id)
        sessionStorage.setItem("floor",value)
        }       
         this.setState(prevState =>({
            ...this.state,
            resultFloor: sessionStorage.getItem("floor"),
            floorId:sessionStorage.getItem("floorId"),
            floorName:sessionStorage.getItem("floorName"),
            show: false,
            floor_plan: flag? prevState.floor_plan: "",
        }))
    }


    onSelect = (event) => {
        this.setState({
            ...this.state,
            [event.target.name]: event.target.value,
            show: false,
        })
    }

    getfilters = (filterList) => {
        let arr = []
        let filter = filterList ? filterList['complexList'] : []
        if (filter) {
            filter.map((data) => {
                arr.push({ value: data[0], label: `${data[0]}(${data[1]})` })
            })
        }
        return arr
    }

    handleOptionChange = (name, name2) => value => {
        if (value != null) {
            this.setState({
                [name]: value,
                [name2]: value
            });
        }
        else {
            this.setState({
                [name]: [],
                [name2]: []
            });
        }
    }

    ErrorDetails = () => {
        appInsights.trackTrace({message: errorDetails, properties:{page: "resultDisplay"}, severityLevel: SeverityLevel.Verbose})
        toast.error(errorDetails, {
            position: toast.POSITION.BOTTOM_RIGHT
        })
        errorDetails = ""
        return true
    }

    isvalidData = (data) => {
        let isValidFromDate = moment(data.datetime).isValid()
        let isValidToDate = moment(data.todatetime).isValid()
        if (data.buildingId && data.floorId && isValidFromDate && isValidToDate && (data.datetime.setHours(0,0,0,0) <= data.todatetime.setHours(0,0,0,0))){
            return true
        }
        else if (!data.buildingId) {
            errorDetails = "Please select a Building!"
            return false
        }
        else if (!data.floorId) {
            errorDetails = "Please select a Floor!"
            return false
        }
        else if (!isValidFromDate || !(data.datetime.setHours(0,0,0,0) <= data.todatetime.setHours(0,0,0,0))) {
            errorDetails = "Plaese select proper From Date!"
            return false
        }
        else if (!isValidToDate) {
            errorDetails = "Please select proper To Date!"
            return false
        }

    }


    applyFilter = () => {
        if (this.isvalidData(this.state)) {
            var data = {
                organism: this.state.resultOrganism,
                date_time: moment.utc(new Date(this.state.datetime)).format("YYYY-MM-DD"),
                to_date: moment.utc(new Date(this.state.todatetime)).format("YYYY-MM-DD"),
                floor__id: this.state.floorId,
                type_of_samples: this.state.resultSampleType,
                analysis: this.state.analysis,
                batch_no: this.state.resultBatchNo,
                building: this.state.buildingId,
                complex_type: this.state.complexFilter ? this.state.complexFilter.toString() : ""
            }

            this.setState({
                show: true,
                clickedFloorArea: undefined,
                floorSampleResults: undefined
            })
            this.fetchLocationAreas(data)
            this.updateWindowDimensions()
        }
        else {
            this.ErrorDetails()
            this.setState({
                resultsData: []
            })
        }
    }

    getDatetime = date => {
        let datetime = new Date()

        datetime.setDate(date.getDate());
        datetime.setMonth(date.getMonth());
        datetime.setFullYear(date.getFullYear());

        return datetime
    }
    

    onChange = date => {
        return this.setState({ date_time: this.getDatetime(date) })
    };

    onDateChange = date => {
        this.setState({ datetime: this.getDatetime(date) }
        )
    }
    onToDateChange = date => {
        this.setState({ todatetime: this.getDatetime(date) }
        )
    }

    resetData = () => {
        this.setState(this.floorInitialState)
    }

    clicked = (area) => {
        this.setState({
            roomName: area.name,
            clickedFloorArea: area,
            floorSampleResults:undefined
        })
    }

    getSampleMapping = (samples_list, coords, locationObject, areas) => {
        if (coords.length > 4){
            coords = locationObject.rect_coordinates.split(",").map(Number)
            }
        let [x1, x2] = coords[0] < coords[2] ? [coords[0], coords[2]] : [coords[2], coords[0]]
        let [y1, y2] = coords[1] < coords[3] ? [coords[1], coords[3]] : [coords[3], coords[1]]
        let [width, height] = [x2 - x1, y2 - y1]

        let len = 10 //length of the square
        let mar = 8 //margin between the squares

        let [samples_width, no_samples_height] = [~~(width / (len + mar)) - 1, ~~(height / (len + mar)) - 1]

        samples_list.map((sampleObject, i) => {
            let preFillColor,strokeColor
            let horiz_count = ~~(i % samples_width) // nth sample position horizontally in location
            let vert_count = ~~(i / samples_width) //  nth sample position vertically in location
            let coords = [x1 + mar * (horiz_count + 1) + len * horiz_count, y1 + mar * (vert_count + 1) + len * vert_count, x1 + mar * (horiz_count + 1) + len * (horiz_count + 1), y1 + mar * (vert_count + 1) + len * (vert_count + 1)]
            preFillColor = (sampleObject.result.other_analysis =="Positive") ? "#f9766e": (sampleObject.result.other_analysis =="Negative") ? "#00bfc4": "#3e58c7"
            strokeColor = (sampleObject.result.other_analysis =="Positive") ? "#f9766e": (sampleObject.result.other_analysis =="Negative") ? "#00bfc4": "#3e58c7"
            areas.push({ name: sampleObject.sample_id, shape: "rect", coords: coords, preFillColor: preFillColor, strokeColor: strokeColor, type: 'sample', rx: '6px' })
        })
        return areas
    }

    getLocationMapping = (locationData) => {
        let areas = []
        let [floor_map, floor_name, floor_plan_width, building_name] = ''
        let floor_data = locationData.floor_data

        floor_map = floor_data.floor_plan
        floor_name = floor_data.floor_name
        floor_plan_width = floor_data.floor_plan_width
        building_name = floor_data.building.building_name

        let locationMapData = locationData.data

        locationMapData.map((locationObject, i) => {
            let coords = locationObject.coordinates.split(",").map(Number)
            let samples_list = locationObject.samples
            let room_id = locationObject.room.room_id
            let sample_areas = []
            let shape = ""
            if(coords.length >4){
                shape = "poly"
            }
            else {
                shape = "room" 
            }
            if (samples_list.length > 0) {
                sample_areas = this.getSampleMapping(samples_list, coords, locationObject, sample_areas)
            }
            //room_name
            areas.push({ name: locationObject.room.room_name, sample_areas: sample_areas, shape: shape, coords: coords, locationObject: locationObject, samples: locationObject.samples, type: 'result_display_room', strokeColor: '#9398c7', preFillColor: "#f1f2f869", fillColor: "#ebfcfc", clickedFillColor: "#dfe2f780", clickedStrokeColor: '#143d8d', text: locationObject.room.room_name });
            areas.push(...sample_areas)
        });
        return [areas, floor_map, floor_name, floor_plan_width, building_name]
    }

    fetchLocationAreas = (data) => {
        this.setState({loader: true})
        this.props.fetchLocationResultsData(data).then(response => {
            if (response.status === 200) {
                if ("locations_data" in response.data && "stats" in response.data) {
                    appInsights.trackTrace({message: 'Flooplan and Location Data is fetched successfully', properties:{page: "resultDisplay", name: response.data.locations_data.floor_data.floor_name, id: this.state.floorId}, severityLevel: SeverityLevel.Information});
                    let locations_data = response.data.locations_data
                    let stats = response.data.stats
                    let sampleData = this.props.locationAreas.locations_data.data
                    let resultData = sampleData.filter((object)=>{
                        if(object.samples.length>0){
                            return object
                        }
                    })

                    let [areas, floor_plan, floor_name, floor_plan_width, building_name] = this.getLocationMapping(locations_data)
                    this.setState({
                        clickedFloorArea: undefined,
                        roomName: areas.length==0?"":areas[0].name,
                        areas: [...areas],
                        floor_plan: floor_plan,
                        floor_name: floor_name,
                        floor_plan_width: floor_plan_width,
                        building_name: building_name,
                        totalSamples: stats.total_samples,
                        totalResults: stats.results,
                        loader: false,
                        floorSampleResults: resultData
                    })
                }
            }
            else {
                this.setState({ loader: false })
                let message = "Errors in loading locations data!"
                appInsights.trackTrace({message: message, properties:{page: "resultDisplay", name: this.state.floorName, id: this.state.floorId}, severityLevel: SeverityLevel.Error});
                toast.error(message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }
        }).catch((error) => {
            let message = "Errors in loading locations data!"
            appInsights.trackTrace({message: message, properties:{page: "resultDisplay", name: this.state.floorName, id: this.state.floorId, error: error}, severityLevel: SeverityLevel.Error});
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        });
    }

    onSelectAnalysis = (e) =>{
        this.setState({
            ...this.state,
            analysis: e.target.value,
            checkedState: (e.target.value == "SNP") ? true : false
        })
    }
    filterWithSelectedDate = (date) => {
            var data = {
                organism: this.state.resultOrganism,
                date_time: moment.utc(new Date(date)).format("YYYY-MM-DD"),
                floor__id: this.state.floorId,
                type_of_samples: this.state.resultSampleType,
                analysis: this.state.analysis
            }
            this.setState({
                show: true,
                clickedFloorArea: undefined,
                floorSampleResults: undefined
            })
            this.fetchLocationAreas(data)
    }
    
    handleButtonClick = (e,value) => {
        let selectedDate = this.state.datetime
        const selectedDateInMilli = new Date(selectedDate).getTime()
        const oneDay = 1000 * 60 * 60 * 24
        let changedDateInMill,changedDate
        if (value == "previous"){
            changedDateInMill = selectedDateInMilli - oneDay
            changedDate = new Date(changedDateInMill)
        }
        else{
            changedDateInMill = selectedDateInMilli + oneDay
            changedDate = new Date(changedDateInMill)
            if (changedDate > new Date()) {
                changedDate = selectedDatess
            }
        }
        
        this.setState({ datetime: changedDate})
        this.filterWithSelectedDate(changedDate)
    
      }

    zoomIn = () => {
        let width = this.state.width
        if (width < 2000) {
            width = width + ((2 / 100) * width)
            this.setState({ width: width, zoomOutEnabled: true, zoomInEnabled: width<2000?true:false})
            
            //To increase each coordinate value to keep the mapping in place
            if(!localStorage.getItem('guest') && !localStorage.getItem('species')){
                this.state.areas.forEach((item, index) =>{
                    let new_coords = []
                    let new_item 
                    item['coords'].forEach((item) => {
                        new_item = item + ((2 / 100) * item)
                        new_coords.push(new_item)
                    })
                    this.state.areas[index]['coords'] = new_coords
                    let new_areas = this.state.areas
                    new_areas.coords = new_coords
                })
                this.setState({areas : this.state.areas})
            }
        }
    }

    zoomOut = () => {
        let actualwidth = window.innerWidth * 0.66
        let width = this.state.width
        if (width > actualwidth) {
            width = width - ((2 / 100) * width)
            this.setState({ width: width, zoomInEnabled: true, zoomOutEnabled: width > actualwidth})
            
            //To decrease each coordinate value to keep the mapping in place
            if(!localStorage.getItem('guest') && !localStorage.getItem('species')){
                this.state.areas.forEach((item, index) =>{
                    let new_coords = []
                    let new_item 
                    item['coords'].forEach((item) => {
                        new_item = item - ((2 / 100) * item)
                        new_coords.push(new_item)
                    })
                    this.state.areas[index]['coords'] = new_coords
                    let new_areas = this.state.areas
                    new_areas.coords = new_coords
                })
                this.setState({areas : this.state.areas})
            }
        }
    }

    render() {
        return (
            <>
            {window.innerWidth>900?
            <div className='page-layout'>
            <NavBar />
              <div className='dashboard-overview results-page' data-tut="reactour__results" ref={(divElement) => { this.divElement = divElement }} >
                        <div className="dashboard-content-25">
                            <Row className="sample-list-header" form>
                                <Navbar className="navbar-results " light expand="md">
                                    <Nav navbar data-tut="reactour__nav">
                                        <NavLink style={{borderBottom: 'none'}} tag={RRNavLink} className="sample-nav-link" activeClassName="active" to="/results/"><span className="nav-col"><img src={radioButtonhighlighted} className="nav-icons" alt=''/>All Results</span></NavLink>
                                        <NavLink tag={RRNavLink} className="sample-nav-link" activeClassName="active" to="/results/trackresults/"><span className="nav-col"><img src={radioButton} className="nav-icons" alt=''/>Track Species</span></NavLink>
                                        <NavLink tag={RRNavLink} className="sample-nav-link" activeClassName="active" to="/results/speciesresults/"><span className="nav-col"><img src={radioButton} className="nav-icons" alt=''/>Species Density</span></NavLink>
                                    </Nav>
                                </Navbar>
                            </Row>
                        <div className='sample-input-area' data-tut="reactour__apply">
                            <Row form>
                                <Col sm={4} md={3} lg={2}>
                                    <Input className={this.state.resultBuilding? this.props.sideBarHover?  "sample-input-fields no-display": "sample-input-fields": this.props.sideBarHover? "sample-input-fields default-disabled no-display":"sample-input-fields default-disabled"} type="select" name="resultBuilding" value={this.state.resultBuilding} onChange={this.onSelectBuilding} size="1">
                                        <option value="" default disabled>Region*</option>
                                        {this.props.buildingList.map((building, key) => {
                                            return <option className="dashboard-options" id={building.id} key={key} value={building.building_id}>{building.building_name}</option>
                                        })}
                                    </Input>
                                </Col>
                                <Col sm={4} md={3} lg={2}>
                                    <Input className={this.state.resultFloor?this.props.sideBarHover?  "sample-input-fields no-display": "sample-input-fields": this.props.sideBarHover? "sample-input-fields default-disabled no-display":"sample-input-fields default-disabled"} type="select" name="resultFloor" value={this.state.resultFloor} onChange={this.onSelectFloor} size="1">
                                        <option value="" default disabled>Map*</option>
                                        {this.props.floorsList.map((floor, key) => {
                                            return <option className="dashboard-options" id={floor.id} key={key} value={floor.id}>{floor.floor_name}</option>
                                        })}
                                    </Input>
                                </Col>
                                <Col sm={4} md={3} lg={2}>
                                    <div>
                                    {!localStorage.getItem("guest")?
                                        <DatePicker
                                            popperProps={{
                                                positionFixed: true
                                            }}
                                            className="sample-input-fields form-control"
                                            wrapperClassName="datepicker-wrapper"
                                            onChange={this.onDateChange}
                                            selected={this.state.datetime}
                                            maxDate={new Date()}
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            dateFormat="MMMM d, yyyy"
                                            dateFormatCalendar=" "
                                            placeholderText="From*"
                                            autoComplete='off'
                                            popperModifiers={{
                                                preventOverflow: {
                                                  enabled: true,
                                                },
                                              }}
                                        />
                                        :
                                        <DatePicker
                                        popperProps={{
                                            positionFixed: true
                                          }}
                                        className="sample-input-fields form-control"
                                        wrapperClassName="datepicker-wrapper"
                                        selected={this.state.datetime}
                                        onChange={this.onDateChange}
                                        filterDate={(date) => {
                                            return moment() > date;
                                        }}
                                        maxDate={new Date()}
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        dateFormat="MMMM d, yyyy"
                                        dateFormatCalendar=" "
                                        placeholderText="Date*"
                                        popperModifiers={{
                                            preventOverflow: {
                                              enabled: true,
                                            },
                                          }}
                                    />
                                    }
                                    </div>
                                <FontAwesomeIcon className='time-icon' icon={faCalendar} size="lg" />
                                </Col>
                                <Col sm={4} md={3} lg={2}>
                                    <div>
                                        <DatePicker id="floor-date-time" onChange={this.onToDateChange} selected={this.state.todatetime}
                                            popperProps={{
                                                positionFixed: true
                                              }}
                                            className="sample-input-fields form-control"
                                            wrapperClassName="datepicker-wrapper"
                                            maxDate={new Date()}
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            dateFormat="MMMM d, yyyy"
                                            dateFormatCalendar=" "
                                            placeholderText="To*"
                                            autoComplete='off'
                                            portalId='root'
                                            popperModifiers={{
                                                preventOverflow: {
                                                  enabled: true,
                                                },
                                              }}
                                        />
                                    </div><FontAwesomeIcon className='time-icon' icon={faCalendar} size="lg" />
                                </Col>
                                <Col sm={4} md={3} lg={2}>
                                    <Input className={this.state.resultSampleType?this.props.sideBarHover?  "sample-input-fields no-display": "sample-input-fields": this.props.sideBarHover? "sample-input-fields default-disabled no-display":"sample-input-fields default-disabled"} type="select" name="resultSampleType" value={this.state.resultSampleType} onChange={this.onSelect} size="1">
                                        <option value="" default>Type of Sample</option>
                                        {this.props.filters.typeOfSamplesList ? this.props.filters.typeOfSamplesList.map((sample, key) => {
                                            return <option className="dashboard-options" id={sample} key={key} value={sample}>{sample}</option>
                                        }) : null}
                                    </Input>
                                </Col>
                                <Col sm={4} md={3} lg={2}>
                                    <Input className={this.state.resultOrganism?this.props.sideBarHover?  "sample-input-fields no-display": "sample-input-fields": this.props.sideBarHover? "sample-input-fields default-disabled no-display":"sample-input-fields default-disabled"} type="select" name="resultOrganism" value={this.state.resultOrganism} onChange={this.onSelect} size="1">
                                        <option value="" default>Organism</option>
                                        {this.props.filters.organismList ? this.props.filters.organismList.map((organism) => {
                                            return <option key={organism} className="dashboard-options" id={organism} value={organism}>{organism}</option>
                                        }) : null}
                                    </Input>
                                </Col>
                                <Col sm={4} md={3} lg={2}>
                                    <Input className={this.props.sideBarHover? "sample-input-fields no-display":"sample-input-fields"} type="select" name="analysis" id="floorId" value={this.state.analysis} onChange={this.onSelectAnalysis} size="1">
                                        <option className="dashboard-options" value="SNP" default>WGS</option>
                                        <option className="dashboard-options" value="Other">Other</option>
                                    </Input>
                                </Col>
                                <Col className="clear-apply-end" data-tut="reactour__apply">
                                    <Button className="sample-clear-button" id="clearButton" outline color="secondary" type="reset" onClick={this.resetData}>Clear</Button>
                                    <Button id="applyFloorButton" type="submit" onClick={this.applyFilter}>Apply{this.state.loader ? <Spinner className="sample-floor-spinner" /> : null}</Button>
                                </Col>
                            </Row>
                        </div>
                        </div>
                    <div className="grid-data width">
                        {this.state.show ?
                            <>
                                <Row className="sample-list-header samples-page" data-tut="reactour__floor" form>
                                    <Col style={{maxWidth: 'fit-content'}}>
                                        <Navbar className="navbar-results" light expand="md">
                                            <Nav navbar data-tut="reactour__grid">
                                            <NavLink tag={RRNavLink} className="sample-nav-link" activeClassName="active" to="/results/"><span className="nav-col"><img src={eyeIcon} className="nav-icons" alt=""/>Map View</span></NavLink>
                                            <NavLink tag={RRNavLink} className="sample-nav-link" activeClassName="active" to="/results/viewresults/grid-view" ><span className="nav-col"><img src={listIcon} className="nav-icons" alt=''/>List View</span></NavLink>
                                            </Nav>
                                        </Navbar>
                                    </Col>
                                        <div className='floorview-header-text'>
                                        <Col className="results-count-text" style={{marginRight: '5%'}}>Sample Taken <span className="samples-count-value">{this.state.totalSamples}</span>
                                        </Col>
                                        <Col className="results-count-text">Results Available <span className="samples-count-value">{this.state.totalResults}</span>
                                        </Col>
                                        </div>
                                    <hr style={{ marginBottom: 0 }} />
                                </Row>
                                
                                {this.state.clickedFloorArea ?

                                    <ResultDisplaySamples roomDetails={this.state.clickedFloorArea} roomName={this.state.roomName}></ResultDisplaySamples>
                                    :
                                    null
                                }
                                {this.state.floorSampleResults ?
                                    <FloorResultDisplay roomDetails={this.state.floorSampleResults} datetime={this.state.datetime} ></FloorResultDisplay>
                                    :
                                    null
                                }
                                <Row className="d-flex justify-content-end">
                                    <Col sm={1} md={1} lg={1} className="zoom-borders">
                                        <div className={"border-icons border-icons-left"+(this.state.zoomInEnabled?"":" border-icons-disable")} id="ZoomIn" onClick={this.zoomIn} >
                                            <img id="ZoomIn" src={zoomInIcon} alt=''/>
                                                <UncontrolledTooltip placement="top" target="ZoomIn">
                                                    Zoom In
                                                </UncontrolledTooltip>
                                            </div>
                                            <div className={"border-icons border-icons-right"+(this.state.zoomOutEnabled?"":" border-icons-disable")} id="ZoomOut" onClick={this.zoomOut}>
                                                <img src={zoomOutIcon} alt=''/>
                                                <UncontrolledTooltip placement="top" target="ZoomOut">
                                                    Zoom Out
                                                </UncontrolledTooltip>
                                            </div>
                                    </Col>
                                </Row>
                                {this.state.areas && this.state.floor_plan ?
                                         <Row>
                                            <Col className="center-align floorplan-overflow">
                                                <ImageMapper
                                                    ref={this.floorElement}
                                                    id='map'
                                                    src={this.state.floor_plan}
                                                    key={this.state.areas.length}
                                                    map={{ name: this.state.name, areas: this.state.areas }}
                                                    imgWidth={this.state.floor_plan_width}
                                                    width={this.state.width }
                                                    currentlyClickedArea={this.state.clickedFloorArea}
                                                    onClick={area => this.clicked(area)}
                                                />
                                            </Col>
                                            </Row>
                                    : null}
                            </>
                            :
                            <>
                            <Row className="sample-list-header" form>
                                    <Navbar className="navbar-results" light expand="md">
                                        <Nav navbar data-tut="reactour__grid">
                                        <NavLink tag={RRNavLink} className="sample-nav-link" activeClassName="active" to="/results/"><span className="nav-col"><img src={eyeIcon} className="nav-icons" alt=''/>Map View</span></NavLink>
                                        <NavLink tag={RRNavLink} className="sample-nav-link" activeClassName="active" to="/results/viewresults/grid-view" ><span className="nav-col"><img src={listIcon} className="nav-icons" alt=''/>List View</span></NavLink>
                                        </Nav>
                                    </Navbar>
                                </Row>
                                <div className="no-data-msg results-data">Select above criteria and click on Apply button to view data. </div>
                                </>
                            }
                    </div>
                    </div>
                    <ToastContainer autoClose={3000} />
                {this.props.isTourOpen?<Tour isOpen={this.props.isTourOpen} closeTour={this.props.closeTour} openTour={this.props.openTour} />:null}
        </div>
        :
        <>
        <div className='dashboard-overview samples-page' data-tut="reactour__results" ref={(divElement) => { this.divElement = divElement }} >
                        <div className="dashboard-content-25">
                            <Row className="sample-list-header" form>
                                <Navbar className="navbar-results " light expand="md">
                                    <Nav navbar data-tut="reactour__nav">
                                        <NavLink style={{borderBottom: 'none'}} tag={RRNavLink} className="sample-nav-link" activeClassName="active" to="/results/"><span className="nav-col"><img src={radioButtonhighlighted} className="nav-icons" alt=''/>All Results</span></NavLink>
                                        <NavLink tag={RRNavLink} className="sample-nav-link" activeClassName="active" to="/results/trackresults/"><span className="nav-col"><img src={radioButton} className="nav-icons" alt=''/>Track Species</span></NavLink>
                                    </Nav>
                                </Navbar>
                            </Row>
                        <div className='sample-input-area' data-tut="reactour__apply">
                            <Row form>
                                <Col sm={4} md={3} lg={2}>
                                    <Input className={this.state.resultBuilding? this.props.sideBarHover?  "sample-input-fields no-display": "sample-input-fields": this.props.sideBarHover? "sample-input-fields default-disabled no-display":"sample-input-fields default-disabled"} type="select" name="resultBuilding" value={this.state.resultBuilding} onChange={this.onSelectBuilding} size="1" required>
                                        <option value="" default disabled>Building*</option>
                                        {this.props.buildingList.map((building, key) => {
                                            return <option className="dashboard-options" id={building.id} key={key} value={building.building_id}>{building.building_name}</option>
                                        })}
                                    </Input>
                                </Col>
                                <Col sm={4} md={3} lg={2}>
                                    <Input className={this.state.resultFloor?this.props.sideBarHover?  "sample-input-fields no-display": "sample-input-fields": this.props.sideBarHover? "sample-input-fields default-disabled no-display":"sample-input-fields default-disabled"} type="select" name="resultFloor" value={this.state.resultFloor} onChange={this.onSelectFloor} size="1" required>
                                        <option value="" default disabled>Floor*</option>
                                        {this.props.floorsList.map((floor, key) => {
                                            return <option className="dashboard-options" id={floor.id} key={key} value={floor.id}>{floor.floor_name}</option>
                                        })}
                                    </Input>
                                </Col>
                                <Col sm={4} md={3} lg={2}>
                                    <div>
                                    {!localStorage.getItem("guest")?
                                        <DatePicker
                                            className="sample-input-fields form-control"
                                            wrapperClassName="datepicker-wrapper"
                                            onChange={this.onDateChange}
                                            selected={this.state.datetime}
                                            maxDate={new Date()}
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            dateFormat="MMMM d, yyyy"
                                            dateFormatCalendar=" "
                                            placeholderText="From*"
                                            autoComplete='off'
                                            popperModifiers={{
                                                preventOverflow: {
                                                  enabled: true,
                                                },
                                              }}
                                            popperProps={{
                                                positionFixed: true
                                            }}
                                        />
                                        :
                                        <DatePicker
                                        className="sample-input-fields form-control"
                                        wrapperClassName="datepicker-wrapper"
                                        selected={this.state.datetime}
                                        onChange={this.onDateChange}
                                        filterDate={(date) => {
                                            return moment() > date;
                                        }}
                                        maxDate={new Date()}
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        dateFormat="MMMM d, yyyy"
                                        dateFormatCalendar=" "
                                        placeholderText="Date*"
                                        popperModifiers={{
                                            preventOverflow: {
                                              enabled: true,
                                            },
                                          }}
                                          popperProps={{
                                            positionFixed: true
                                          }}
                                    />
                                    }
                                    </div>
                                </Col>
                                <Col sm={4} md={3} lg={2}>
                                    <div>
                                        <DatePicker id="floor-date-time" onChange={this.onToDateChange} selected={this.state.todatetime}
                                            className="sample-input-fields form-control"
                                            wrapperClassName="datepicker-wrapper"
                                            maxDate={new Date()}
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            dateFormat="MMMM d, yyyy"
                                            dateFormatCalendar=" "
                                            placeholderText="To*"
                                            autoComplete='off'
                                            portalId='root'
                                            required="true"
                                            popperModifiers={{
                                                preventOverflow: {
                                                  enabled: true,
                                                },
                                              }}
                                              popperProps={{
                                                positionFixed: true
                                              }}
                                              
                                        />
                                    </div>
                                </Col>
                                <Col sm={4} md={3} lg={2}>
                                    <Input className={this.state.resultSampleType?this.props.sideBarHover?  "sample-input-fields no-display": "sample-input-fields": this.props.sideBarHover? "sample-input-fields default-disabled no-display":"sample-input-fields default-disabled"} type="select" name="resultSampleType" value={this.state.resultSampleType} onChange={this.onSelect} size="1">
                                        <option value="" default style={{ color: "gray" }}>Type of Sample</option>
                                        {this.props.filters.typeOfSamplesList ? this.props.filters.typeOfSamplesList.map((sample, key) => {
                                            return <option className="dashboard-options" id={sample} key={key} value={sample}>{sample}</option>
                                        }) : null}
                                    </Input>
                                </Col>
                                <Col sm={4} md={3} lg={2}>
                                    <Input className={this.state.resultOrganism?this.props.sideBarHover?  "sample-input-fields no-display": "sample-input-fields": this.props.sideBarHover? "sample-input-fields default-disabled no-display":"sample-input-fields default-disabled"} type="select" name="resultOrganism" value={this.state.resultOrganism} onChange={this.onSelect} size="1">
                                        <option value="" default style={{ color: "gray" }}>Organism</option>
                                        {this.props.filters.organismList ? this.props.filters.organismList.map((organism) => {
                                            return <option key={organism} className="dashboard-options" id={organism} value={organism}>{organism}</option>
                                        }) : null}
                                    </Input>
                                </Col>
                                <Col sm={4} md={3} lg={2}>
                                    <Input className={this.props.sideBarHover? "sample-input-fields no-display":"sample-input-fields"} type="select" name="analysis" id="floorId" value={this.state.analysis} onChange={this.onSelectAnalysis} size="1">
                                        <option className="dashboard-options" value="SNP" default>WGS</option>
                                        <option className="dashboard-options" value="Other">Other</option>
                                    </Input>
                                </Col>
                                <Col className="clear-apply-end" data-tut="reactour__apply">
                                    <Button className="sample-clear-button" id="clearButton" outline color="secondary" type="reset" onClick={this.resetData}>Clear</Button>
                                    <Button id="applyFloorButton" type="submit" onClick={this.applyFilter}>Apply{this.state.loader ? <Spinner className="sample-floor-spinner" /> : null}</Button>
                                </Col>
                            </Row>
                        </div>
                        </div>
                    <div className="grid-data">
                        {this.state.show ?
                            <div data-tut="reactour__floor">
                                <Row className="sample-list-header samples-page width" form>
                                    <Col style={{maxWidth: 'fit-content'}}>
                                        <Navbar className="navbar-results" light expand="md">
                                            <Nav navbar data-tut="reactour__grid">
                                            <NavLink tag={RRNavLink} className="sample-nav-link" activeClassName="active" to="/results/"><span className="nav-col"><img src={eyeIcon} style={{paddingRight: "7px", paddingBottom: "3px"}} alt=''/>Map View</span></NavLink>
                                            <NavLink tag={RRNavLink} className="sample-nav-link" activeClassName="active" to="/results/viewresults/grid-view" ><span className="nav-col"><img src={listIcon} style={{paddingRight: "7px", paddingBottom: "1px"}} alt=''/>List View</span></NavLink>
                                            </Nav>
                                        </Navbar>
                                    </Col>
                                        <div className='floorview-header-text'>
                                        <Col className="results-count-text" style={{marginRight: '5%'}}>Sample Taken <span className="samples-count-value">{this.state.totalSamples}</span>
                                        </Col>
                                        <Col className="results-count-text">Results Available <span className="samples-count-value">{this.state.totalResults}</span>
                                        </Col>
                                        </div>
                                    <hr style={{ marginBottom: 0 }} />
                                </Row>
                                
                                {this.state.clickedFloorArea ?

                                    <ResultDisplaySamples roomDetails={this.state.clickedFloorArea} roomName={this.state.roomName}></ResultDisplaySamples>
                                    :
                                    null
                                }
                                {this.state.floorSampleResults ?
                                    <FloorResultDisplay roomDetails={this.state.floorSampleResults} datetime={this.state.datetime} ></FloorResultDisplay>
                                    :
                                    null
                                }
                                <Row className="d-flex justify-content-end">
                                    <Col sm={1} md={1} lg={1} className="zoom-borders">
                                        <div className="border-icons border-icons-left" id="ZoomIn" onClick={this.zoomIn} >
                                            <img id="ZoomIn" src={zoomInIcon} alt=''/>
                                                <UncontrolledTooltip placement="top" target="ZoomIn">
                                                    Zoom In
                                                </UncontrolledTooltip>
                                            </div>
                                            <div className="border-icons border-icons-right" id="ZoomOut" onClick={this.zoomOut}>
                                                <img src={zoomOutIcon} alt=''/>
                                                <UncontrolledTooltip placement="top" target="ZoomOut">
                                                    Zoom Out
                                                </UncontrolledTooltip>
                                            </div>
                                    </Col>
                                </Row>
                                {this.state.areas && this.state.floor_plan ?
                                         <Row>
                                            <Col className="center-align floorplan-overflow">
                                                <ImageMapper
                                                    ref={this.floorElement}
                                                    id='map'
                                                    src={this.state.floor_plan}
                                                    key={this.state.areas.length}
                                                    map={{ name: this.state.name, areas: this.state.areas }}
                                                    imgWidth={this.state.floor_plan_width}
                                                    width={this.state.width }
                                                    currentlyClickedArea={this.state.clickedFloorArea}
                                                    onClick={area => this.clicked(area)}
                                                />
                                            </Col>
                                            </Row>
                                    : null}
                            </div>
                            :
                            <>
                            <Row className="sample-list-header" form>
                                    <Navbar className="navbar-results" light expand="md">
                                        <Nav navbar data-tut="reactour__grid">
                                        <NavLink tag={RRNavLink} className="sample-nav-link" activeClassName="active" to="/results/"><span className="nav-col"><img src={eyeIcon} className="nav-icons" alt=''/>Map View</span></NavLink>
                                        <NavLink tag={RRNavLink} className="sample-nav-link" activeClassName="active" to="/results/viewresults/grid-view" ><span className="nav-col"><img src={listIcon} className="nav-icons" alt=''/>List View</span></NavLink>
                                        </Nav>
                                    </Navbar>
                                </Row>
                                <div className="no-data-msg results-data">Select above criteria and click on Apply button to view data. </div>
                                
                                </>
                            }
                    </div>
                    </div>
                    <ToastContainer autoClose={3000} />
                {this.props.isTourOpen?<Tour isOpen={this.props.isTourOpen} closeTour={this.props.closeTour} openTour={this.props.openTour} />:null}
                </>
    }
        </>
        )
    }
}

const mapStateToProps = state => {
    return {
        locationAreas: state.location_data.locationData,
        buildingList: state.floor_data.buildingsList,
        floorsList: state.floor_data.floorsList,
        filters: state.results_data.filters,
    }
}

export default withAITracking(reactPlugin, connect(
    mapStateToProps,
    {
        fetchLocationResultsData,
        fetchBuilding,
        fetchFloors,
        fetchFloorPlan,
        saveSample,
        updateSample,
        deleteSample,
        fetchFilterOptions
    }
)(ResultDisplay), 'View Results', 'ResultDisplay')